module.exports = __webpack_public_path__ + "img/R06_S3.65a41abe.jpg";